










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class InsFacebook extends Vue {
  get isMobile () {
    return this.$store.state.isMobile;
  }

  mounted () {
    // this.getContent();
  }
}
